{
  "title": "Project access",
  "intro": "Who may see and change {{name}}. Administrators see every project; members only those given to them, as owner or guest.",
  "readOnly": "Only administrators change who has access to a project.",
  "add": "Add a person",
  "addLead": "Give a member of your organisation access to this project.",
  "addSubmit": "Give access",
  "added": "{{name}} now has access",
  "person": "Person",
  "accessColumn": "Access",
  "nobodyToAdd": "Every member already has access here. Invite new people in Users and access.",
  "meaning": {
    "owner": "Full rights inside this project: create, change and delete resources, the console, root passwords.",
    "guest": "Looks only: resources, dashboard, metrics, activity and costs. No changes."
  },
  "empty": "Nobody has access yet",
  "emptyLead": "Administrators always see this project. Add members to let them work in it.",
  "makeOwner": "Make owner",
  "makeGuest": "Make guest",
  "changed": "Access of {{name}} changed",
  "adminRow": "Administrator",
  "adminRowReason": "Administrators see every project; change their role in Users and access",
  "remove": "Remove access",
  "removeTitle": "Remove {{name}} from {{project}}?",
  "removeHidden": "The project disappears for them at once: lists, pages and live updates.",
  "removeKeep": "Their account and access to other projects stay.",
  "removed": "{{name}} no longer has access"
}
